/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Offerdetail_Overview_Igdbreviews2Inputs */

const id_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("id", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} ulasan`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} ulasan`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const ms_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ms", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} ulasan`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} ulasan`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const da_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("da", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} anmeldelse`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} anmeldelser`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const de_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} Bewertung`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} Bewertungen`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const en_us2_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en-US", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} review`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} reviews`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const es_es2_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-ES", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} reseña`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} reseñas`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const es_mx2_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-MX", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} reseña`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} reseñas`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const fil_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fil", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} review`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} review`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const fr_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} avis`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} avis`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const it_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("it", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} recensione`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} recensioni`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const hu_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hu", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} értékelés`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} értékelés`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const nl_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} review`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} reviews`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const no_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("no", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} omtale`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} omtaler`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const pl_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} recenzja`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} recenzji`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const pt_br2_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt-BR", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Revisão de ${i?.count}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} comentários`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const pt_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} avaliação`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} avaliações`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const ro_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ro", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} recenzie`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} recenzii`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const fi_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} arvostelu`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} arvostelua`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const sv_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("sv", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} recension`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} recensioner`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const vi_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("vi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} đánh giá`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} đánh giá`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const tr_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("tr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} yorum`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} yorum`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const cs_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("cs", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} recenze`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} recenzí`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const bg_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("bg", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} ревю`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} ревюта`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const ru_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ru", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} обзор`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} обзоров`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const uk_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("uk", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} відгук`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} відгуків`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const ar_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ar", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} مراجعة`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} مراجعة`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const hi_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} समीक्षा`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} समीक्षाएँ`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const th_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("th", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} รีวิว`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} รีวิว`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const ja_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ja", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} レビュー`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} レビュー`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const zh_cn2_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-CN", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} 条评论`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} 条评论`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const zh_hant1_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-Hant", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} 條評論`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} 條評論`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

const ko_offerdetail_overview_igdbreviews2 = /** @type {(inputs: Offerdetail_Overview_Igdbreviews2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ko", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`리뷰 ${i?.count}개`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`리뷰 ${i?.count}개`);
	return /** @type {LocalizedString} */ ("offerDetail.overview.igdbReviews");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} review" |
* | "other" | "{count} reviews" |
*
* @param {Offerdetail_Overview_Igdbreviews2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_overview_igdbreviews2 = /** @type {((inputs: Offerdetail_Overview_Igdbreviews2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Overview_Igdbreviews2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "ms") return ms_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "da") return da_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "de") return de_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "fil") return fil_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "fr") return fr_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "it") return it_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "hu") return hu_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "nl") return nl_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "no") return no_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "pl") return pl_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "pt") return pt_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "ro") return ro_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "fi") return fi_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "sv") return sv_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "vi") return vi_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "tr") return tr_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "cs") return cs_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "bg") return bg_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "ru") return ru_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "uk") return uk_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "ar") return ar_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "hi") return hi_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "th") return th_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "ja") return ja_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_overview_igdbreviews2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_overview_igdbreviews2(inputs)
	return ko_offerdetail_overview_igdbreviews2(inputs)
});
export { offerdetail_overview_igdbreviews2 as "offerDetail.overview.igdbReviews" }